import { IDocumentCategoryModel } from '@api/models';
import { createDocumentFolder } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

import * as Yup from 'yup';

// TODO Folder Interface latter
const AddFolderSchema = Yup.object({
    name: Yup.string().trim().required('This field is required'),
});

const useCreateFolderForm = (clientId: string) => {
    const createFolderMutation = useMutation((payload: Pick<IDocumentCategoryModel, 'name'>) =>
        createDocumentFolder(clientId, payload)
    );

    const submit = async (values: Pick<IDocumentCategoryModel, 'name'>) => {
        const newFolder = await createFolderMutation.mutateAsync(values);

        return newFolder;
    };

    return { isLoading: createFolderMutation.isPending, schema: AddFolderSchema, submit };
};

export default useCreateFolderForm;
